//
// Expression.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "../../moduleBuilder";
import ClosetObject from "../../ClosetObject";
import "../../lib";
import "./DataTypeExt";
import "./ExpressionError";

var Expression = createModule("commons::Expression", [], ClosetObject, [
    ,
    ,
    ,
    ,
    {
        evaluateAsBoolean: [2,1],
        evaluateAsNumber: [6,1],
        getDataType: [4],
        isCharacterExpression: [2],
        isBooleanExpression: [2],
        invalidate: [0,2],
        isNumericExpression: [2],
        hasValidStructure: [2],
        hasValidTypeAgreement: [2],
        getValidationErrors: [[4]],
        isLeaf: [2],
        evaluateAsString: [7,1],
        debugLogInvalidExpression: [0],
        resolveParameters: [[1],1],
        isConstant: [2],
        getAllExpressionsWithPreorderTraversal: [[1],2],
        isKeyword: [2],
        isValidForContext: [2,1],
        toString: [7],
    },
    ,
    ,
]);
export default Expression;
